import { useAccountCompanyId } from 'application/hooks';
import { ModalTypes, useModalContext } from 'application/providers/ModalProvider';
import { useNavigate } from 'application/providers/RouterProvider';

import { useCurrentUserSberConnection } from '@entities/auth';
import { BILLING_PAGE_PATH_ALIAS } from '@entities/billing';

import { useStartAcceptanceAdvancedSigning } from './useStartAcceptanceAdvancedSigning';
import { IS_NEED_SHOW_UNPAID_LICENSES_MODAL_KEY } from './sberBusinessOnlineStorageKeys';

interface UseAcceptanceAdvancedModalProps {
  close: (count?: number) => void;
  afterClose?: () => void;
}

interface UseAcceptanceAdvancedModal {
  hasSberConnection: boolean;
  startSigningAcceptanceAdvancedLoading: boolean;
  handleRedirectToAcceptanceAdvanced: () => void;
  handleClose: () => void;
  handleShowBillingPage: () => void;
}

const useAcceptanceAdvancedModal = ({
  close,
  afterClose,
}: UseAcceptanceAdvancedModalProps): UseAcceptanceAdvancedModal => {
  const { openModal } = useModalContext();
  const navigate = useNavigate();

  const companyId = useAccountCompanyId();
  const hasSberConnection = useCurrentUserSberConnection();

  const { startSigningAcceptanceAdvancedLoading, startSigningAcceptanceAdvanced } = useStartAcceptanceAdvancedSigning();

  const onConfirmRedirectToAcceptanceAdvanced = () => {
    startSigningAcceptanceAdvanced(companyId);
    close();
    afterClose?.();
  };

  const handleRedirectToAcceptanceAdvanced = () => {
    openModal(ModalTypes.SBER_REDIRECT_WARNING, { onConfirm: onConfirmRedirectToAcceptanceAdvanced });
  };

  const handleClose = () => {
    localStorage.removeItem(IS_NEED_SHOW_UNPAID_LICENSES_MODAL_KEY);
    close();
  };

  const handleShowBillingPage = () => {
    navigate(BILLING_PAGE_PATH_ALIAS, { replace: true });
    close(2);
    localStorage.removeItem(IS_NEED_SHOW_UNPAID_LICENSES_MODAL_KEY);
  };

  return {
    hasSberConnection,
    startSigningAcceptanceAdvancedLoading,
    handleRedirectToAcceptanceAdvanced,
    handleClose,
    handleShowBillingPage,
  };
};

export default useAcceptanceAdvancedModal;
